<div class="rfq-output">

    <app-bread-crumbs [navigationRoute]="currentRoute" [currentPageString]="currentPageString" [clickHandler]="returnToRFQ"
        [breadCrumbFlow]="breadCrumbFlow" [activePage]="activePage">
    </app-bread-crumbs>

    <div class="page-container">
        <app-layout class="container--form">
            <ng-container app-layout-above-inner-container *ngIf="rfqOutputService.rfqOutput$ | async as rfqOutput">
                <ng-container *ngIf="hasRFQChanges(rfqOutput.data?.RFQ)">
                    <shared-alert [type]="alertType.Info">
                        <p class="mb-0" alert-content>Please go back to the previous page and click on “<strong>Update
                                and send
                                RFQ</strong>” for the changes on this page to take effect.</p>
                    </shared-alert>
                </ng-container>
            </ng-container>



            <mat-tab-group class="pt-0" dynamicHeight mat-stretch-tabs="false" mat-align-tabs="start">

                <mat-tab label="Current RFQ" bodyClass="mt-0">

                    <ng-container *ngIf="rfqOutputService.rfqOutput$ | async as rfqOutput">
                        <ng-container
                            *ngIf="!rfqOutput.isLoading && !rfqOutput.error && rfqOutput.data; else listingSpinnerErrorTemplate">

                            <ng-container
                                *ngIf="rfqOutput.data.RFQ && rfqOutput.data.RFQ.length > 0 && rfqOutput.data.RFQ[0].MPDocumentNumber === MPDocumentNumber; else placeholderMessageTemplate">


                                <div class="table-wrapper">

                                    <table class="mat-elevation-z3 table-content" mat-table multiTemplateDataRows
                                        matSort [dataSource]="rfqDataSource">
                                        <ng-container matColumnDef="{{ column }}"
                                            *ngFor="let column of RFQDisplayColumns">
                                            <div *ngIf="column === 'Version'">
                                                <th mat-header-cell *matHeaderCellDef>Version</th>
                                            </div>

                                            <div *ngIf="column === 'RFQNumber'">
                                                <th mat-header-cell *matHeaderCellDef>RFQ no.</th>
                                            </div>

                                            <div *ngIf="column === 'PurchaseExecutive'">
                                                <th mat-header-cell *matHeaderCellDef>Purchasing Executive</th>
                                            </div>

                                            <div *ngIf="column === 'RFQDeadline'">
                                                <th mat-header-cell *matHeaderCellDef>RFQ deadline</th>
                                            </div>

                                            <div *ngIf="column === 'LastEmailPrinted'">
                                                <th mat-header-cell *matHeaderCellDef>Last emailed/printed</th>
                                            </div>

                                            <div *ngIf="column === 'ItemNumber'">
                                                <th mat-header-cell *matHeaderCellDef>Item no.</th>
                                            </div>

                                            <div *ngIf="column === 'VendorName'">
                                                <th mat-header-cell *matHeaderCellDef>Vendor name</th>
                                            </div>

                                            <div *ngIf="column === 'Action'">
                                                <th class="freeze-right" mat-header-cell *matHeaderCellDef>Action</th>
                                            </div>

                                            <div *ngIf="column === 'Version'">
                                                <td class="link" mat-cell *matCellDef="let element"><span
                                                        (click)="onDownloadMultiple(element.data['uploadPaths'])">{{
                                                        element[column] }}</span></td>
                                            </div>
                                            <div *ngIf="column === 'RFQDeadline'">
                                                <td mat-cell *matCellDef="let element">{{
                                                    (element.data['newRFQDeadline'] || element[column]) | date:
                                                    'dd-MMM-yy, h:mm a'}}</td>
                                            </div>
                                            <div *ngIf="column === 'LastEmailPrinted'">
                                                <td mat-cell *matCellDef="let element">{{ element[column] | date:
                                                    'dd-MMM-yy, h:mm a'}}</td>
                                            </div>

                                            <div *ngIf="column === 'Action'">
                                                <ng-template #tooltipTemplateDisableEdit>
                                                    <div class="custom-tooltip">
                                                        <p>
                                                            1. If system RFQ is required, only a Purchasing Executive may edit the RFQ deadline.
                                                            <br />
                                                            <br />
                                                            2. If system RFQ is NOT required, only the requesting officer or document creator may edit the RFQ deadline.
                                                            <br />
                                                            <br />
                                                            3. If RFQ summary has been raised, no deadline changes can be made.
                                                            <br />
                                                            <br />
                                                            For any questions, kindly contact the PMM for assistance.
                                                        </p>
                                                    </div>
                                                  </ng-template>
                                                <td class="freeze-right" mat-cell *matCellDef="let element" [tp]="tooltipTemplateDisableEdit"
                                                    tpClassName="custom-tooltip" tpMaxWidth="300px" [tpInteractive]="true"
                                                    [tpIsEnabled]="isAllowEditRFQDeadline(element.RFQDeadline,element.data.isRfqSummaryRaised)">
                                                    <button mat-icon-button (click)="onEditRFQDeadline({
                                                                                                        RFQNumber: element.RFQNumber,
                                                                                                        initialSentDate: element.data.initialSentDate,
                                                                                                        RFQDeadline: element.RFQDeadline,
                                                                                                        newRFQDeadline: element.data.newRFQDeadline,
                                                                                                        })"
                                                        [disabled]="isAllowEditRFQDeadline(element.RFQDeadline,element.data.isRfqSummaryRaised)">
                                                        <mat-icon>edit</mat-icon>
                                                    </button>
                                                </td>
                                            </div>
                                            <div
                                                *ngIf="!['Version', 'RFQDeadline', 'LastEmailPrinted', 'Action', 'data'].includes(column)">
                                                <td mat-cell *matCellDef="let element">{{ element[column] }}</td>
                                            </div>
                                        </ng-container>
                                        <tr mat-header-row *matHeaderRowDef="RFQDisplayColumns"></tr>
                                        <tr mat-row *matRowDef="let row; columns: RFQDisplayColumns;"></tr>
                                    </table>
                                </div>
                                <mat-paginator #rfqPaginator [pageSize]="defaultPageSize"
                                    [pageSizeOptions]="pageSizeOptions" showFirstLastButtons></mat-paginator>

                            </ng-container>
                        </ng-container>
                    </ng-container>

                </mat-tab>

                <mat-tab label="Output history" bodyClass="mt-0">

                    <ng-container *ngIf="rfqOutputService.rfqOutput$ | async as rfqOutput">

                        <ng-container
                            *ngIf="!rfqOutput.isLoading && !rfqOutput.error && rfqOutput.data; else listingSpinnerErrorTemplate">

                            <ng-container
                                *ngIf="rfqOutput.data.outputHistories && rfqOutput.data.outputHistories.length > 0 && rfqOutput.data.outputHistories[0].MPDocumentNumber === MPDocumentNumber; else placeholderMessageTemplate">

                                <div class="table-wrapper">
                                    <table class="mat-elevation-z3 table-content" mat-table multiTemplateDataRows
                                        matSort [dataSource]="outputHistoryDataSource">
                                        <ng-container matColumnDef="{{ column }}"
                                            *ngFor="let column of OutputHistoryDisplayColumns">
                                            <div *ngIf="column === 'VersionNumber'">
                                                <th mat-header-cell *matHeaderCellDef> Version </th>
                                            </div>
                                            <div *ngIf="column === 'Type'">
                                                <th mat-header-cell *matHeaderCellDef>Output</th>
                                            </div>
                                            <div *ngIf="column === 'RFQNumber'">
                                                <th mat-header-cell *matHeaderCellDef>RFQ Number</th>
                                            </div>
                                            <div *ngIf="column === 'Name'">
                                                <th mat-header-cell *matHeaderCellDef>Vendor Name</th>
                                            </div>
                                            <div *ngIf="column === 'Email'">
                                                <th mat-header-cell *matHeaderCellDef> Email ID </th>
                                            </div>
                                            <div *ngIf="column === 'ModifiedOn'">
                                                <th mat-header-cell *matHeaderCellDef> Output datetime</th>
                                            </div>
                                            <div *ngIf="column === 'RFQDeadline'">
                                                <th mat-header-cell *matHeaderCellDef> RFQ deadline</th>
                                            </div>
                                            <div *ngIf="column === 'CreatedBy'">
                                                <th mat-header-cell *matHeaderCellDef> Personnel</th>
                                            </div>
                                            <div *ngIf="column === 'TempStatus'">
                                                <th mat-header-cell *matHeaderCellDef> Status</th>
                                            </div>
                                            <div *ngIf="column === 'TempReason'">
                                                <th mat-header-cell *matHeaderCellDef> Reason</th>
                                            </div>
                                            <div>
                                                <th mat-header-cell *matHeaderCellDef> {{ formatHeader(column) }}
                                                </th>
                                            </div>
                                            <div *ngIf="column === 'VersionNumber'">
                                                <td class="link" mat-cell *matCellDef="let element">
                                                    <span
                                                        (click)="onDownloadSingle(element.MPDocumentNumber, element.VendorNumber, element.RFQNumber, element.VersionNumber)">{{
                                                        element[column] }}</span>
                                                </td>
                                            </div>
                                            <div *ngIf="column === 'ModifiedOn' || column === 'RFQDeadline'">
                                                <td mat-cell *matCellDef="let element">{{ element[column] | date:
                                                    'dd-MMM-yy, h:mm a'}}</td>
                                            </div>
                                            <div
                                                *ngIf="column !== 'VersionNumber' && column !== 'ModifiedOn' && column !== 'RFQDeadline'">
                                                <td mat-cell *matCellDef="let element">{{ element[column] }}</td>
                                            </div>
                                        </ng-container>
                                        <tr mat-header-row *matHeaderRowDef="OutputHistoryDisplayColumns"></tr>
                                        <tr mat-row *matRowDef="let row; columns: OutputHistoryDisplayColumns;">
                                        </tr>
                                    </table>
                                </div>
                                <mat-paginator #outputHistoryPaginator [pageSize]="defaultPageSize"
                                    [pageSizeOptions]="pageSizeOptions" showFirstLastButtons></mat-paginator>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </mat-tab>
            </mat-tab-group>
        </app-layout>
    </div>
</div>

<ng-template #listingSpinnerErrorTemplate>
    <ng-container *ngIf="rfqOutputService.rfqOutput$ | async as rfqOutput">
        <div *ngIf="rfqOutput.isLoading || (!rfqOutput.error && !rfqOutput.data)">
            <mat-spinner class="listing-spinner"></mat-spinner>
            <div class="listing-spinner-text paragraph-medium-regular">
                <p>Retrieving data...</p>
            </div>
        </div>
        <app-add-reference-card *ngIf="rfqOutput.error" [desc]="rfqOutput.error">
        </app-add-reference-card>
    </ng-container>
</ng-template>

<ng-template #placeholderMessageTemplate>
    <app-add-reference-card desc="No records were found."></app-add-reference-card>
</ng-template>
